var plugin_default = {
  "alignLeft": "U21wi",
  "textWrapNowrap": "I65MC",
  "alignRight": "cjQDd",
  "alignCenter": "aF1MP",
  "sizeFullWidth": "u2EBZ",
  "renderedInTable": "mjMZJ",
  "sizeOriginal": "mkGyJ",
  "sizeContent": "A3y4J",
  "sizeSmall": "NvIiy",
  "sizeSmallCenter": "cVD3-",
  "flex": "IlgLo",
  "atomic": "PLeZA",
  "embed": "ex-ek",
  "horizontalScrollbar": "GNP3I",
  "pluginContainerMobile": "ob8W9"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
